<template id="recherche">
    <div class="recherche-container">
        <div class="flex-container">
            <div class="form-group input-group tx-solr-search-form" id="tx-solr-search-form-pi-results">
                <label class="label-invisible" for="recherche_par_ville">Municipalité</label>
                <input v-model="rechercheVille" style="position: relative;" class="tx-solr-q js-solr-q tx-solr-suggest tx-solr-suggest-focus form-control" role="search" aria-label="Recherche d'une municipalité" autocomplete="off" id="recherche_par_ville" type="text" @keyup.enter="onClickEnter"/>
                <button id="x_reset_ville"  v-show="rechercheVille" @click="onClickResetMunicipalite" type="button" aria-label="Bouton pour effacer le champ Municipalité" class="btn_reset_input_inside"><span><svg xmlns="http://www.w3.org/2000/svg" fill="#095797" version="1.1" width="16" height="16" viewBox="0 0 40 40">
<path d="M21.414 21l17.293-17.293c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-17.293 17.293-17.293-17.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414l17.293 17.293-17.293 17.293c-0.391 0.391-0.391 1.024 0 1.414 0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293l17.293-17.293 17.293 17.293c0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293c0.391-0.391 0.391-1.024 0-1.414l-17.293-17.293z"/>
</svg></span></button>
            </div>
            <div class="form-group input-group tx-solr-search-form" id="tx-solr-search-form-pi-results2">
                <label class="label-invisible" for="recherche_par_etablissement">Nom de l'établissement</label>
                <input  v-model="rechercheEtablissement" style="position: relative;" class="tx-solr-q js-solr-q tx-solr-suggest tx-solr-suggest-focus form-control" role="search" aria-label="Recherche d'un établissement" autocomplete="off" id="recherche_par_etablissement" type="text" @keyup.enter="onClickEnter"/>
                <button id="x_reset_etablissement"  v-show="rechercheEtablissement" @click="onClickResetEtablissement" type="button" aria-label="Bouton pour effacer le champ Nom d'établissement" class="btn_reset_input_inside"><span><svg xmlns="http://www.w3.org/2000/svg" fill="#095797" version="1.1" width="16" height="16" viewBox="0 0 40 40">
<path d="M21.414 21l17.293-17.293c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-17.293 17.293-17.293-17.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414l17.293 17.293-17.293 17.293c-0.391 0.391-0.391 1.024 0 1.414 0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293l17.293-17.293 17.293 17.293c0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293c0.391-0.391 0.391-1.024 0-1.414l-17.293-17.293z"/>
</svg></span></button>
            </div>
        </div>
        <span class="input-group-btn">
            <button  aria-label="Bouton pour filtrer par établissement et ou ville inscrite dans le champs de recherche établissement et ville" type="button" class="btn btn-primary" @click="onClickRecherche"><span class="glyphicon glyphicon-search"></span><span>Rechercher</span></button>
        </span>
    </div>
</template>

<script>
    export default{
        name:"RechercheCond",
        components: {
    
        },
        emits: ['filtreRecherche'],
        props: {
    
        },
        data() {
            return {
            rechercheVille: '',
            rechercheEtablissement: ''
            }
        },
        methods:{
            onClickRecherche(){
                let rechercheVille=document.getElementById('recherche_par_ville').value;
                let rechercheEtablissement=document.getElementById('recherche_par_etablissement').value;
                this.$emit('filtreRecherche',rechercheVille,rechercheEtablissement);
            },
            onClickEnter(){
                this.onClickRecherche()
            },
            onClickResetMunicipalite(){
                document.querySelector('#recherche_par_ville').value = '';
                this.rechercheVille = ''
            },
            onClickResetEtablissement(){
                document.querySelector('#recherche_par_etablissement').value = '';
                this.rechercheEtablissement = ''
            }
        },
        computed: {
    
        }
    }
</script>